import App from '@/App';
import { ROUTES } from '@/configs/constants';
import withAuthentication from '@/hooks/withAuthentication';
import withNonAuthentication from '@/hooks/withNonAuthentication';
import AdminPanelLayout from '@/layouts/AdminPanelLayout';
import FormPanelLayout from '@/layouts/FormPanelLayout';
import {
    SignUpPage, CalendarPage, DashboardPage, LoginPage, ModalPage, NotFoundPage, PaginationPage, ReactToastifyPage, TablePage, TabsPage, UserManagementPage,
    HomePage, FinishSignUpPage, ProfilePage, EditProfilePage, QRProfilePage, TermsOfServicePage, PrivacyPolicyPage, FaqPage,
    HowToUsePage, InputEmailPage, InputOtpPage, ListItemsPage, SetLocationItemPage, CollectedItemsPage, DetailItemCollected,
    EditRegisteredItemPage, RegisterNewItem, ListNearByPage, LandingPage
} from '@/pages';
import { createBrowserRouter, redirect } from 'react-router-dom';

const AdminPanelLayoutWithAuthentication = withAuthentication(AdminPanelLayout);
const FormPanelLayoutWithNoneAuthentication = withNonAuthentication(FormPanelLayout);

export const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            {
                path: ROUTES.landing.href,
                element: <LandingPage />
            },
            {
                path: '/',
                element: <FormPanelLayoutWithNoneAuthentication />,
                children: [
                    {
                        path: ROUTES.login.href,
                        element: <LoginPage />
                    },
                    {
                        path: ROUTES.signUp.href,
                        element: <SignUpPage />
                    },
                    {
                        path: ROUTES.finishSignUp.href,
                        element: <FinishSignUpPage />
                    }
                ]
            },
            {
                path: '/',
                element: <AdminPanelLayout />,
                children: [
                    {
                        path: ROUTES.dashboard.href,
                        element: <DashboardPage />
                    },
                    {
                        path: ROUTES.home.href,
                        element: <HomePage />
                    },
                    {
                        path: ROUTES.calendar.href,
                        element: <CalendarPage />
                    },
                    {
                        path: ROUTES.pagination.href,
                        element: <PaginationPage />
                    },
                    {
                        path: ROUTES.table.href,
                        element: <TablePage />
                    },
                    {
                        path: ROUTES.reactToastify.href,
                        element: <ReactToastifyPage />
                    },
                    {
                        path: ROUTES.modal.href,
                        element: <ModalPage />
                    },
                    {
                        path: ROUTES.tabs.href,
                        element: <TabsPage />
                    },
                    {
                        path: ROUTES.userManagement.href,
                        element: <UserManagementPage />
                    },
                    {
                        path: ROUTES.profile.href,
                        element: <ProfilePage />
                    },
                    {
                        path: ROUTES.editProfile.href,
                        element: <EditProfilePage />
                    },
                    {
                        path: ROUTES.qrProfile.href,
                        element: <QRProfilePage />
                    },
                    {
                        path: ROUTES.termsOfService.href,
                        element: <TermsOfServicePage />
                    },
                    {
                        path: ROUTES.privacyPolicy.href,
                        element: <PrivacyPolicyPage />
                    },
                    {
                        path: ROUTES.faq.href,
                        element: <FaqPage />
                    },
                    {
                        path: ROUTES.howToUse.href,
                        element: <HowToUsePage />
                    },
                    {
                        path: ROUTES.inputEmail.href,
                        element: <InputEmailPage />
                    },
                    {
                        path: ROUTES.inputOtp.href,
                        element: <InputOtpPage />
                    },
                    {
                        path: ROUTES.listItems.href,
                        element: <ListItemsPage />
                    },
                    {
                        path: ROUTES.setLocationItem.href,
                        element: <SetLocationItemPage />
                    },
                    {
                        path: ROUTES.collectefItems.href,
                        element: <CollectedItemsPage />
                    },
                    {
                        path: ROUTES.detailItemCollected.href,
                        element: <DetailItemCollected />
                    },
                    {
                        path: ROUTES.editRegisteredItem.href,
                        element: <EditRegisteredItemPage />
                    },
                    {
                        path: ROUTES.registerNewItem.href,
                        element: <RegisterNewItem />
                    },
                    {
                        path: ROUTES.listNearBy.href,
                        element: <ListNearByPage />
                    }
                ]
            },
            {
                path: '*',
                element: <NotFoundPage />
            }
        ]
    }
]);
